import CustomButton from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import Modal from "common/components/Modal/Modal"
import SwitchButtons from "common/components/SwitchButtons"
import { AppContext } from "common/context/WithAppWrapper"
import useToggle from "common/hooks/useToggle"
import ArticulosSelected from "features/Inventario/components/ArticulosSelected"
import ArticulosSelection from "features/Inventario/components/ArticulosSelection"
import CatalogosTree from "features/Inventario/components/CatalogosTree"
import ImagePreview from "features/Inventario/components/ImagePreview"
import useCatalogos from "features/Inventario/hooks/useCatalogos"
import {
  createCatalogo,
  updateCatalogo,
} from "features/Inventario/redux/slices/catalogosSlice"
import { withFormik } from "formik"
import { nanoid } from "nanoid"
import { Badge } from "primereact/badge"
import { useContext, useEffect, useRef, useState } from "react"
import { Box, ShoppingCart } from "react-feather"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useHistory } from "react-router-dom"
import "./catalogoForm.scss"

const CATEGORIAS = "Categorías"
const ARTICULOS = "Artículos"

const SWITCH_BTNS = (t: $TSMigrationFixMe) => [
  {
    id: nanoid(),
    text: `${t("catalogos.editCreate.switch.headerCategory")}`,
    Icon: Box,
  },
  {
    id: nanoid(),
    text: `${t("catalogos.editCreate.switch.headerArticles")}`,
    Icon: ShoppingCart,
  },
]

const NewCatalogoForm = ({
  handleSubmit,
  setFieldValue,
  values,
  isEditing,
  catalogoId,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const switchBtns = SWITCH_BTNS(t)
  const [whichView, setWhichView] = useState(CATEGORIAS)
  const [showModalArticulosSelected, toggleShowModalArticulosSelected] =
    useToggle(false)
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)
  const history = useHistory()
  const parentArticulosRef = useRef()

  const [maxHeightArticulosContainer, setMaxHeightArticulosContainer] =
    useState(600)
  useEffect(() => {
    // @ts-expect-error TS(2339): Property 'clientHeight' does not exist on type 'ne...
    const height = parentArticulosRef.current?.clientHeight - 300
    if (height > 600) {
      setMaxHeightArticulosContainer(height)
    }
  }, [parentArticulosRef])

  const {
    categoriasTree,
    manyArticulosSelected,
    creatingCatalogo,
    fetchingCatalogosTree,
    articulosSelected,
    updatingCatalogo,
    isReadyToCreateOrUpdate,
    handleSetCategoriasTree,
    handleSelectCategoria,
    handleUnSelectCategorias,
  } = useCatalogos({ catalogoId })

  const setImage = (image: $TSMigrationFixMe) => {
    setFieldValue("imageFile", image)
    setFieldValue("imagenBase64", null)
    setFieldValue("ficheroId", null)
  }

  const deleteImage = () => {
    setImage(null)
  }

  const onDrop = (files: $TSMigrationFixMe) => {
    setImage(files?.[0])
  }

  const labelAction = isEditing
    ? `${t("catalogos.editCreate.titleEdit")}`
    : `${t("catalogos.editCreate.titleCreate")}`

  return (
    <div className='wrap-form-catalogo'>
      <div className='p-3 text-left catalogo-form-container'>
        <form
          className='h-100'
          onSubmit={handleSubmit}
        >
          <div className='d-flex justify-content-between'>
            <p className='text-gedesco f-21'>{labelAction}</p>

            <span className='d-flex'>
              <CustomButton
                onClick={() => history.goBack()}
                className='text'
                label={`${t("catalogos.editCreate.cancelButton")}`}
              />

              <CustomButton
                type='submit'
                disabled={!isReadyToCreateOrUpdate}
                loading={creatingCatalogo || updatingCatalogo}
                className='ml-2'
                label={labelAction}
              />
            </span>
          </div>

          <div
            // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
            ref={parentArticulosRef}
            className='row h-100'
          >
            <div className='col-lg-5'>
              <div className='mt-3 p-fluid'>
                <div className='p-field'>
                  <label htmlFor='catalogoName'>
                    {t("catalogos.editCreate.form.labelName")}
                  </label>
                  <FormikInputText
                    id='catalogoName'
                    name='nombre'
                  />
                </div>
                <div className='p-fluid'>
                  <label>{t("catalogos.editCreate.form.labelImg")}</label>

                  <ImagePreview
                    image={values.imageFile}
                    imagenBase64={values.imagenBase64}
                    imagenMediaType={values.imagenMediaType}
                    setImage={setImage}
                    deleteImage={deleteImage}
                  />

                  {!values.imageFile && !values.imagenBase64 && (
                    <Dropzone
                      maxFiles={1}
                      accept='image/*'
                      acceptLabel='image/*'
                      onDrop={onDrop}
                      hideAcceptedFilesMsg
                      butonLabel={`${t(
                        "catalogos.editCreate.form.buttonLabelImg"
                      )}`}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className='col-lg-7'>
              <div className='mt-4 d-flex justify-content-between'>
                <SwitchButtons
                  btns={switchBtns}
                  onSelect={({ text }: $TSMigrationFixMe) => setWhichView(text)}
                />

                <CustomButton
                  onClick={toggleShowModalArticulosSelected}
                  className='raised'
                >
                  <i
                    className='pi pi-shopping-cart p-overlay-badge'
                    style={{ fontSize: "1.4em" }}
                  >
                    <Badge
                      style={{
                        backgroundColor: settings.primary,
                        color: "white",
                      }}
                      value={manyArticulosSelected}
                    />
                  </i>

                  <span className='ml-2'>
                    {t("catalogos.editCreate.form.labelArtSelected")}
                  </span>
                </CustomButton>
              </div>

              <div
                // @ts-expect-error TS(2339): Property 'clientHeight' does not exist on type 'ne...
                style={{ height: parentArticulosRef.current?.clientHeight }}
                className='mt-3 catalogos-articulos-selection'
              >
                <ArticulosSelection
                  // @ts-expect-error TS(2322): Type '{ maxHeight: number; visible: boolean; }' is...
                  maxHeight={maxHeightArticulosContainer}
                  visible={whichView === ARTICULOS}
                />

                <CatalogosTree
                  maxHeight={maxHeightArticulosContainer}
                  loading={fetchingCatalogosTree}
                  items={categoriasTree}
                  setItems={handleSetCategoriasTree}
                  visible={whichView === CATEGORIAS}
                  selectCategorias={handleSelectCategoria}
                  unSelectCategorias={handleUnSelectCategorias}
                  articulosSelected={articulosSelected}
                />
              </div>
            </div>
          </div>

          <Modal
            className='modalWithoutPadding'
            header={t("catalogos.editCreate.modal.header")}
            visible={showModalArticulosSelected}
            onHide={toggleShowModalArticulosSelected}
          >
            <ArticulosSelected
              disabled={!isReadyToCreateOrUpdate}
              onCreate={handleSubmit}
              onHide={toggleShowModalArticulosSelected}
              labelOnAction={labelAction}
            />
          </Modal>
        </form>
      </div>
    </div>
  )
}

const NewCatalogo = withFormik({
  // @ts-expect-error TS(2339): Property 'catalogo' does not exist on type '{}'.
  mapPropsToValues: ({ catalogo }) => ({
    nombre: catalogo?.nombre || "",
    imageFile: catalogo?.imageFile || "",
    ficheroId: catalogo?.ficheroId,
    imagenBase64: catalogo?.imagenBase64,
    imagenMediaType: catalogo?.imagenMediaType,
  }),
  // @ts-expect-error TS(7030): Not all code paths return a value.
  validate: (values) => {
    if (!values.nombre) return { nombre: "El nombre está vacío." }
  },
  handleSubmit: (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'isEditing' does not exist on type 'objec...
    if (props.isEditing) {
      // @ts-expect-error TS(2339): Property 'updateCatalogo' does not exist on type '...
      props.updateCatalogo({ ...values, catalogoId: props.catalogoId })
    } else {
      // @ts-expect-error TS(2339): Property 'createCatalogo' does not exist on type '...
      props.createCatalogo(values)
    }
  },
})(NewCatalogoForm)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  createCatalogo: (payload: $TSMigrationFixMe) =>
    dispatch(createCatalogo(payload)),
  updateCatalogo: (payload: $TSMigrationFixMe) =>
    dispatch(updateCatalogo(payload)),
})

export default connect(null, mapDispatchToProps)(NewCatalogo)
